import React from "react";
import { Link } from "react-router-dom";
import TeamData from "../../data/team/TeamData.json";

const allData = TeamData;

// Intrinsic pixel dimensions for the team thumbnails, used to reserve
// layout space (CLS) alongside loading="lazy". Most thumbs are 640x640;
// team-8.png differs, so dimensions are looked up per thumb path.
const thumbDimensions = {
  "/images/team/team-1.webp": { width: 640, height: 640 },
  "/images/team/team-2.webp": { width: 640, height: 640 },
  "/images/team/team-3.webp": { width: 640, height: 640 },
  "/images/team/team-4.webp": { width: 640, height: 640 },
  "/images/team/team-5.webp": { width: 640, height: 640 },
  "/images/team/team-6.webp": { width: 640, height: 640 },
  "/images/team/team-7.webp": { width: 640, height: 640 },
  "/images/team/team-8.png": { width: 128, height: 128 },
};

const TeamOne = () => {
  return (
    <div className="section section-padding bg-color-dark pb--70 pb_lg--20 pb_md--0">
      <div className="container">
        <div className="section-heading heading-light">
          <h2 className="title mb--50">Industries We've Served</h2>
          <p>
            We have a diverse portfolio because of the industry-wide exposure.
            Sectors we’ve served so far :
          </p>
        </div>
        <div className="row">
          {allData.map((data) => (
            <div className="col-xl-3 col-sm-6" key={data.id}>
              <div className="team-grid">
                <div className="thumbnail">
                  <Link to={process.env.PUBLIC_URL}>
                    <img
                      src={process.env.PUBLIC_URL + data.thumb}
                      alt={data.title}
                      loading="lazy"
                      width={thumbDimensions[data.thumb] ? thumbDimensions[data.thumb].width : undefined}
                      height={thumbDimensions[data.thumb] ? thumbDimensions[data.thumb].height : undefined}
                    />
                  </Link>
                </div>
                <div className="content">
                  <h3 className="title">
                    {/* <Link
                      to={
                        process.env.PUBLIC_URL +
                        `/team-details/${slugify(data.title)}`
                      }
                    > */}
                    {data.title}
                    {/* </Link> */}
                  </h3>
                  {/* <span
                    className="designation"
                    dangerouslySetInnerHTML={{ __html: data.designation }}
                  ></span> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <ul className="list-unstyled shape-group-10">
        <li className="shape shape-1">
          <img
            src={process.env.PUBLIC_URL + "/images/others/circle-1.png"}
            alt="Circle"
            loading="lazy"
            width="663"
            height="663"
          />
        </li>
        <li className="shape shape-2">
          <img
            src={process.env.PUBLIC_URL + "/images/others/line-3.png"}
            alt="Circle"
            loading="lazy"
            width="550"
            height="550"
          />
        </li>
        <li className="shape shape-3">
          <img
            src={process.env.PUBLIC_URL + "/images/others/bubble-5.png"}
            alt="Circle"
            loading="lazy"
            width="105"
            height="106"
          />
        </li>
      </ul>
    </div>
  );
};

export default TeamOne;
